<div *ngIf="dashboardCard" [ngClass]="[isPrimary ? '' : 'isSecondary']" class="col-md-12 main-container">
  <div [ngClass]="[isDisabledController ? 'is-disabled' : '']">
    <div class="header-icon-container">
      <div class="icon-container">
        <mat-icon svgIcon="{{ dashboardCard.svg }}"></mat-icon>
      </div>
      <h3 class="header-text">{{ dashboardCard.header }}</h3>
    </div>
    <div class="sub-text">
      {{ dashboardCard.descriptionText }}
    </div>
    <div class="details-container text-center">
      <div class="details-content">
        <div class="col-12">
          <div class="info-main-line">{{ dashboardCard.leftHeader }}</div>
        </div>
        <div class="col-12">
          <div class="info-sub-line">{{ dashboardCard.leftSubText }}</div>
        </div>
      </div>
      <div class="vertical-divider"></div>
      <div class="details-content">
        <div class="col-12">
          <div class="info-main-line">{{ dashboardCard.rightHeader }}</div>
        </div>
        <div class="col-12">
          <div class="info-sub-line">{{ dashboardCard.rightSubText }}</div>
        </div>
      </div>
    </div>
    <div class="text-center action-btn-container">
      <button
        class="mat-stroked-button"
        color="primary"
        routerLink="{{ dashboardCard.buttonRoute }}"
        [disabled]="isDisabledController"
        [gtmClick]="dashboardCard.buttonText"
        gtmLinkURL="CTA">
        {{ dashboardCard.buttonText }}
      </button>
    </div>
  </div>
</div>
